import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RatesList from './ratesList';
import RateModel from '../../models/rateModel';
import RateGroup from '../../models/rateGroup';
import RateForm from './rateForm';
import PageError from '../error/pageError';

export default class Rates extends React.Component {
    render() {
        const { path } = this.props;
        const organizationId = this.props.organization.id;

        return (
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={routeProps => <RatesList organization={this.props.organization} event={this.props.event} menhirUrl={this.props.menhirUrl} />}
                />

                <Route
                    exact
                    path={`${path}/:rateId([0-9]+)`}
                    render={basenameProps => {
                        const rateId = basenameProps.match.params.rateId;
                        return (
                            <RateForm
                                rateId={rateId}
                                organizationId={organizationId}
                                event={this.props.event}
                                menhirUrl={this.props.menhirUrl}
                                history={basenameProps.history}
                                RateClass={RateModel}
                                GroupClass={RateGroup}
                            />
                        );
                    }}
                />

                <Route
                    exact
                    path={`${path}/new`}
                    render={basenameProps => {
                        return (
                            <RateForm
                                organizationId={organizationId}
                                event={this.props.event}
                                menhirUrl={this.props.menhirUrl}
                                history={basenameProps.history}
                                RateClass={RateModel}
                                GroupClass={RateGroup}
                            />
                        );
                    }}
                />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}/E${this.props.event.id}`} />} />
            </Switch>
        );
    }
}

Rates.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    menhirUrl: PropTypes.string.isRequired
};
